import script from "./competitior.vue?vue&type=script&setup=true&lang=js"
export * from "./competitior.vue?vue&type=script&setup=true&lang=js"

import "./competitior.vue?vue&type=style&index=0&id=259b3f81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-259b3f81"]])

export default __exports__